import { ComponentRef, Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { take } from 'rxjs/operators';


@Injectable()
export class OverlayRef<T = any, C = any> {

    private _result = new Subject<T>();

    private canDismiss = () => of(true);

    get result(): Subject<T> {
        return this._result;
    }

    componentRef: ComponentRef<C>;

    registerDismissGuard(fn: () => Observable<boolean>) {
        this.canDismiss = fn;
    }

    close(value: T) {
        this._result.next(value);
        this._result.complete();
        this.componentRef.destroy();
    }

    dismiss(_reason?: string) {
        this.canDismiss().pipe(take(1)).subscribe(canDismiss => {
            if (canDismiss) {
                this._result.complete();
                this.componentRef.destroy();
            }
        });
    }
}
